import TrailTable from "components/common/TrailTable/TrailTable";
import { useAppSelector } from "store";

type EntityType = "category" | "collection" | "tag";

interface Prop {
  type: EntityType;
}

const TrailTab: React.FC<Prop> = ({ type }) => {
  const entityId = useAppSelector((store) => {
    const map = {
      category: store.categories.payload?.id,
      collection: store.collections.payload?.id,
      tag: store.tags.payload?.id,
    };
    return map[type];
  });
  if (!entityId) return null;

  return (
    <>
      <TrailTable entityType={type} entityId={entityId} />
    </>
  );
};

export default TrailTab;
